<template>
  <div>
    <ECase class="mb-4"/>
    <FilterOptions class="mb-4"/>
    <History class="mb-4"/>

<!--    <MultiLanguage caption="Title" :items="title"/>-->

  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import Dashboard from "@/views/Dashboard.vue";
import ECase from "@/projects/views/dashboards/components/case.vue";
import FilterOptions from "@/projects/views/dashboards/components/options.vue";
import ListsNotifile from "@/projects/views/dashboards/components/lists.vue";
import History from "@/projects/views/dashboards/components/history.vue";
import MultiLanguage from "@/projects/components/Util/MultiLanguage.vue";

export default {
  name: 'Dashborads',
  components: {MultiLanguage, History, ListsNotifile, FilterOptions, ECase, Dashboard},
  props: {
    icon: {
      type: String,
      default: 'cil-bell'
    },
    caption: {
      type: String,
      default: 'ศูนย์แจ้งเหตุฉุกเฉิน'
    },
    application: {
      type: String,
      default: '0'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,
    loading:{
      type: Boolean,
      default() {
        return false
      }
    },

  },
  data() {
    return {
      title: [{key: "th", value: ""}, {key: "en", value: ""}],
      his: "",
      horizontal: { label:'col-3', input:'col-9' },
      options:{
        type:['Option 1', 'Option 2', 'Option 3'],
      },
      fields: [
        {key:"type", label: "ประเภท" ,},
        {key:"limit", label: "ขั้นต่ำ" ,},
        {key:"max", label: "สูงสุด" ,},
        {key:"maxByOrder", label: "สูงสุดต่อเลข" ,}
      ],
      item:[{
        type:"3 ตัวบน",
        limit:1,
        max:10000,
        maxByOrder:10000
      },{
        type:"3 ตัวล่าง",
        limit:1,
        max:10000,
        maxByOrder:10000
      },{
        type:"3 ตัวโต๊ด",
        limit:1,
        max:10000,
        maxByOrder:10000
      },{
        type:"2 ตัวบน",
        limit:1,
        max:10000,
        maxByOrder:10000
      },{
        type:"2 ตัวล่าง",
        limit:1,
        max:10000,
        maxByOrder:10000
      },{
        type:"2 ตัวโต๊ด",
        limit:1,
        max:10000,
        maxByOrder:10000
      },{
        type:"วิ่งบน",
        limit:1,
        max:10000,
        maxByOrder:10000
      },{
        type:"วิ่งล่าง",
        limit:1,
        max:10000,
        maxByOrder:10000
      }]
    }
  },

  mounted() {

  },

  created() {
    this.onInit();
  },

  beforeDestroy() {

  },

  methods: {
    onInit() {

    },
  },

  computed: {
    ...mapGetters({
    })
  },

  watch: {
    lang: function (value) {

    },


  }
}

</script>
